import { useContext } from 'react';
import AppContext from '@context';
import { getEventsHistory } from '@services/journeys';

const useLoadJourneyHistory = ({ journeyId }: { journeyId: string }) => {
  const { dispatch } = useContext(AppContext);

  const fetchHistory = async () => {
    if (journeyId) {
      dispatch({ type: 'journey_history_loading' });

      return getEventsHistory(journeyId)
        .then((response) => {
          dispatch({ type: 'journey_history_success', payload: response.data });
        })
        .catch(() => {
          dispatch({ type: 'journey_history_error' });
        });
    }

    return Promise.reject(new Error('journeyId not found'));
  };

  return { fetchHistory };
};

export default useLoadJourneyHistory;
